import { render, staticRenderFns } from "./AfterSale.vue?vue&type=template&id=f2fea27a&scoped=true"
import script from "./AfterSale.vue?vue&type=script&lang=js"
export * from "./AfterSale.vue?vue&type=script&lang=js"
import style0 from "./AfterSale.vue?vue&type=style&index=0&id=f2fea27a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fea27a",
  null
  
)

export default component.exports